import { Dispatch, FC, SetStateAction, useMemo, useRef } from 'react'
import { Marker } from 'react-leaflet'
import * as L from 'leaflet'

interface IProps {
  center: L.LatLngTuple
  children: JSX.Element
  draggable: boolean
  handleClick: () => void
  setDragging: Dispatch<SetStateAction<boolean>>
  handlePositionChange: (value: { lat: number; lng: number }) => void
  icon?: L.Icon
}

const DraggableMarker: FC<IProps> = ({
  center,
  children,
  draggable,
  setDragging,
  handleClick,
  handlePositionChange,
  icon,
}) => {
  const markerRef = useRef<any>(null)

  const eventHandlers = useMemo(
    () => ({
      click: handleClick,
      dragend() {
        const marker = markerRef.current
        if (marker != null) {
          handlePositionChange(marker.getLatLng())
        }
      },
      mousedown: () => {
        setDragging(true)
      },
      mouseup: () => {
        setDragging(false)
      },
    }),
    [],
  )

  // We get a crash if `icon` is undefined and passed as a prop,
  // so only pass it if we have a value:
  const attrs: any = {}
  if (icon) attrs.icon = icon
  return (
    <Marker draggable={draggable} eventHandlers={eventHandlers} position={center} ref={markerRef} {...attrs}>
      {children}
    </Marker>
  )
}

export default DraggableMarker
